import { v5 as uuidv5 } from "uuid";

export const generateUUIDFromID = (id: string) => {
  const namespace = "your-namespace"; // Replace with your own namespace
  const fullString = `${namespace}:${id}`;
  const uuid = uuidv5(fullString, uuidv5.DNS);

  return uuid;
};

export const isUUID = (id: string): boolean =>
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(id);

// Anything already synced to our backend keeps its real UUID; only raw,
// not-yet-synced SevDesk records need their numeric id hashed into one.
const toEntityId = (id: string): string =>
  isUUID(id) ? id : generateUUIDFromID(id);

export const toPropertyId = toEntityId;

export const toProductId = toEntityId;
